import React from "react";
import { Routes, Route } from "react-router-dom";
import HeaderSiteVisit from "../Components/SiteVisit/headerSiteVisit";
import SiteVisitList from "../Components/SiteVisit/siteVisitList";
import SiteVisitRentalList from "../Components/SiteVisit/rentalSiteVisit";
import AgentSiteVisitList from "../Components/SiteVisit/agentSiteVisit";
import ViewSiteVisit from "../Components/SiteVisit/viewSiteVisit";
import FranchiseSiteVisitList from "../Components/SiteVisit/franchiseSiteVisitList";
import ViewSiteVisitRental from "../Components/SiteVisit/viewRentalSiteVisit";
import ViewAgentSiteVisit from "../Components/SiteVisit/viewAgentSiteVisit";
import ViewFracnhiseSiteVisit from "../Components/SiteVisit/viewFranchiseSiteVisit";

const SiteVisitRoutes = () => {
  return (
    <Routes>
      <Route path="/site_visit" element={<HeaderSiteVisit />} />
      <Route path="/user_site_visit" element={<SiteVisitList />} />
      <Route path="/rental_site_visit" element={<SiteVisitRentalList />} />
      <Route path="/agent_site_visit" element={<AgentSiteVisitList />} />
      <Route path="/franchise_site_visit" element={<FranchiseSiteVisitList />} />
      <Route path="/site-visit/:id" element={<ViewSiteVisit />} />
      <Route path="/site-visit-rental/:id" element={<ViewSiteVisitRental />} />
      <Route path="/agent-site-visit/:id" element={<ViewAgentSiteVisit />} />
      <Route path="/franchise-site-visit/:id" element={<ViewFracnhiseSiteVisit />} />
    </Routes>
  );
};

export default SiteVisitRoutes;
